import { useMutation } from '@tanstack/react-query';
import { ApiClient, useApiClient } from 'api/context-provider/useApiClient';
import { ApiError, InferFetchData, throwOnError } from 'api/helpers';

export function useAbortWorkshopDeletionMutation(workshopId: number) {
  const apiClient = useApiClient();
  return useMutation<InferFetchData<typeof abortWorkshopDeletion>, ApiError, undefined>({
    mutationKey: ['AbortWorkshopDeletion', workshopId],
    mutationFn: () => throwOnError(abortWorkshopDeletion(apiClient, workshopId)),
  });
}

async function abortWorkshopDeletion(apiClient: ApiClient, workshopId: number) {
  return apiClient.POST('/op/v2/workshops/{workshop_id}/abort-deletion', {
    params: {
      path: {
        workshop_id: workshopId,
      },
    },
  });
}
